import Logo from "@/components/site/Logo";
import { CONTACT } from "@/lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[color:var(--ww-white)] border-t border-black/10 py-14"
    >
      <div className="max-w-[92rem] mx-auto px-5 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-4 text-sm text-black/55 max-w-md leading-relaxed">
            Modern websites, software and digital systems for Irish service
            businesses. Designed and built in-house.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-[10px] uppercase tracking-[0.26em] text-emerald-700 font-semibold">
            Menu
          </p>
          <ul className="mt-4 space-y-2 text-sm text-black/70">
            <li><a href="#work" data-testid="footer-nav-work" className="hover:text-black">Work</a></li>
            <li><a href="#services" data-testid="footer-nav-services" className="hover:text-black">Services</a></li>
            <li><a href="#process" data-testid="footer-nav-process" className="hover:text-black">Process</a></li>
            <li><a href="#contact" data-testid="footer-nav-contact" className="hover:text-black">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-[10px] uppercase tracking-[0.26em] text-emerald-700 font-semibold">
            Contact
          </p>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="footer-contact-email"
                className="text-black hover:text-emerald-700"
              >
                {CONTACT.email}
              </a>
            </li>
            <li>
              <a
                href={`tel:${CONTACT.phoneRaw}`}
                data-testid="footer-contact-phone"
                className="text-black/75 hover:text-black"
              >
                {CONTACT.phone}
              </a>
            </li>
            <li className="text-black/55">Built in Ireland · serving nationwide</li>
          </ul>
        </div>
      </div>

      <div className="max-w-[92rem] mx-auto px-5 md:px-10 mt-10 pt-6 border-t border-black/5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-black/45">
        <span>© {new Date().getFullYear()} Website Walsh. All rights reserved.</span>
        <span>Designed &amp; built in-house.</span>
      </div>
    </footer>
  );
}
